import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';

@Component({
})

export abstract class FormAutoFocusComponent implements AfterViewInit {
    @ViewChild('focusField', { static: false }) fieldToFocus: ElementRef;

    ngAfterViewInit() {
        this.focusField();
    }

    focusField() {
        if (this.fieldToFocus) this.fieldToFocus.nativeElement.focus();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/formautofocus/formAutoFocus.component.ts